module.exports = __webpack_public_path__ + "static/media/view_reports.87591594.svg";